import { datetimeUtilsMixin } from "@/plugins/utils/time-utils";
import { passwordUtilsMixin } from "@/plugins/utils/password-utils";
import { enumUtilsMixin } from "@/plugins/utils/enum-utils";
import {screenUtilsMixin} from "@/plugins/utils/screen-utils";

export default {
    install: (app, options) => {
        app.mixin(datetimeUtilsMixin);
        app.mixin(passwordUtilsMixin);
        app.mixin(enumUtilsMixin);
        app.mixin(screenUtilsMixin);
    }
};
